import { graphql } from "gatsby";
import { SlidersBasic, SlidersMinMax, SlidersStep } from "../../../../src/examples/components/Sliders";
import * as React from 'react';
export default {
  graphql,
  SlidersBasic,
  SlidersMinMax,
  SlidersStep,
  React
};